import { fabric } from 'fabric';
import { grid } from './FabricHelper';

export const onObjMoving = (target: fabric.Object | undefined) => {
    const snap = grid / 10; //Pixels to snap, set to be the grid size but can be changed
    if (!target) {
        return;
    }
    let left = Math.max(0, Number(target.left) || 0);
    let top = Math.max(0, Number(target.top) || 0);
    left = Math.min(left, (target.canvas?.width || 0) - (target.width || 0));
    top = Math.min(top, (target.canvas?.height || 0) - (target.height || 0));
    left = Math.round(left / snap) * snap;
    top = Math.round(top / snap) * snap;
    target.left = left;
    target.top = top;
};

export const validatePositions = (target: fabric.Object | undefined) => {
    const snap = grid / 10; //Pixels to snap, set to be the grid size but can be changed
    const canvas = target?.canvas;
    if (!canvas) {
        return;
    }

    let left = Math.max(0, Number(target.left) || 0);
    let top = Math.max(0, Number(target.top) || 0);
    left = Math.min(left, (target.canvas?.width || 0) - (target.width || 0));
    top = Math.min(top, (target.canvas?.height || 0) - (target.height || 0));
    left = Math.round(left / snap) * snap;
    top = Math.round(top / snap) * snap;
    target.left = Math.max(0, left);
    target.top = Math.max(0, top);
    //NOTE: This is used to avoid possible infinite loop
    for (let i = 0; i < 100; i++) {
        const relevantCanvasObjs = getIntersectingObjects(target);
        if (relevantCanvasObjs.length === 0) {
            return;
        }
        relevantCanvasObjs.forEach((object) => {
            const boundingRect = target.getBoundingRect();
            const objBoundingRect = object.getBoundingRect();

            const bLeft = Number(boundingRect.left);
            const bTop = Number(boundingRect.top);
            const bWidth = Number(boundingRect.width);
            const bHeight = Number(boundingRect.height);
            const oLeft = Number(objBoundingRect.left);
            const oTop = Number(objBoundingRect.top);
            const oWidth = Number(objBoundingRect.width);
            const oHeight = Number(objBoundingRect.height);

            let dX = 0;
            let dY = 0;

            if (bLeft + bWidth > oLeft && bLeft + bWidth < oLeft + oWidth) {
                dX = oLeft - bLeft - bWidth;
            }
            if (bLeft < oLeft + oWidth && bLeft + bWidth > oLeft + oWidth) {
                dX = oLeft + oWidth - bLeft;
            }
            if (bTop + bHeight > oTop && bTop + bHeight < oTop + oHeight) {
                dY = oTop - bTop - bHeight;
            }
            if (bTop < oTop + oHeight && bTop + bHeight > oTop + oHeight) {
                dY = oTop + oHeight - bTop;
            }
            if (Math.abs(dX) / oWidth > Math.abs(dY) / oHeight) {
                target.left = (Number(target.left) || 0) + dX;
            } else {
                target.top = (Number(target.top) || 0) + dY;
            }
        });
        canvas.renderAll();
    }
};

export const getIntersectingObjects = (canvasObject: fabric.Object) => {
    return (
        canvasObject.canvas
            ?.getObjects()
            .filter(
                (o) =>
                    !!o.data?.id &&
                    o.data.id !== canvasObject.data?.id &&
                    o.data.zIndex === canvasObject.data?.zIndex &&
                    o.intersectsWithObject(canvasObject),
            )
            // ignore touching elements
            .filter((object) => {
                if (object.isContainedWithinObject(canvasObject) || canvasObject.isContainedWithinObject(object)) {
                    return true;
                }

                const boundingRect = canvasObject.getBoundingRect();
                const objBoundingRect = object.getBoundingRect();
                const bLeft = Number(boundingRect.left);
                const bTop = Number(boundingRect.top);
                const bWidth = Number(boundingRect.width);
                const bHeight = Number(boundingRect.height);
                const oLeft = Number(objBoundingRect.left);
                const oTop = Number(objBoundingRect.top);
                const oWidth = Number(objBoundingRect.width);
                const oHeight = Number(objBoundingRect.height);

                return (
                    bLeft + bWidth !== oLeft &&
                    bLeft !== oLeft + oWidth &&
                    bTop + bHeight !== oTop &&
                    bTop !== oTop + oHeight
                );
            }) || []
    );
};

export function onObjectScaling(object: fabric.Object) {
    const resizeSnap = grid / 4;
    const width = Math.round(object.getScaledWidth() / resizeSnap) * resizeSnap;
    const height = Math.round(object.getScaledHeight() / resizeSnap) * resizeSnap;
    object.set('scaleX', width / (object.width || 0));
    object.set('scaleY', height / (object.height || 1));
}
